import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ArrowLeftBig",
  "use": "svg-icon-ArrowLeftBig-usage",
  "viewBox": "0 0 24 43",
  "content": "<symbol viewBox=\"0 0 24 43\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-ArrowLeftBig\"><path d=\"M21.2 43L0 21.5 21.2 0 24 2.84 5.6 21.5 24 40.16\" opacity=\".8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol